import { Address } from '../../../shared/types/Address';

export interface ValidationResult {
  error?: {
    details: Array<{ path: string[]; message: string }>;
  };
}

const validateAddress = (address: Address | undefined, _options?: { allowUnknown?: boolean }): ValidationResult => {
  const errors: Array<{ path: string[]; message: string }> = [];

  if (!address) {
    errors.push({ path: ['address'], message: 'Address is required' });
    return { error: errors.length > 0 ? { details: errors } : undefined };
  }

  if (!address.country?.trim()) {
    errors.push({ path: ['country'], message: 'Country is required' });
  }

  if (!address.addressLine1?.trim()) {
    errors.push({ path: ['addressLine1'], message: 'Address line 1 is required' });
  }

  if (!address.city?.trim()) {
    errors.push({ path: ['city'], message: 'City is required' });
  }

  if (address.country === 'US' && !address.state?.trim()) {
    errors.push({ path: ['state'], message: 'State is required for US addresses' });
  }

  if (!address.zipCode?.trim()) {
    errors.push({ path: ['zipCode'], message: 'ZIP code is required' });
  }

  return {
    error: errors.length > 0 ? { details: errors } : undefined
  };
};

const AddressSchema = {
  validate: validateAddress
};

export default AddressSchema;